'use strict';

module.exports = function () {
    var testKey = 'local_test';
    try {
        localStorage.setItem(testKey, 1);
        localStorage.removeItem(testKey);
    } catch (e) {
        return false;
    }
    return true;
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/util/ls.js
// module id = 153
// module chunks = 0